/**
 *判断是否是数字
 *
 **/

//适配分辨率
/* function bodyScale() {
	var devicewidth = document.documentElement.clientWidth; //获取当前分辨率下的可是区域宽度
	var scale = devicewidth / 1920; // 分母——设计稿的尺寸
	document.body.style.zoom = scale; //放大缩小相应倍数
} */
function isRealNum(val) {
	// isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除，    
	if (val === "" || val == null) {
		return false;
	}
	if (!isNaN(val)) {
		//对于空数组和只有一个数值成员的数组或全是数字组成的字符串，isNaN返回false，例如：'123'、[]、[2]、['123'],isNaN返回false,   //所以如果不需要val包含这些特殊情况，则这个判断改写为if(!isNaN(val) && typeof val === 'number' )
		return true;
	} else {
		return false;
	}
}

function formatTime(time) {
	if (typeof time !== 'number' || time < 0) {
		return time
	}

	var hour = parseInt(time / 3600)
	time = time % 3600
	var minute = parseInt(time / 60)
	time = time % 60
	var second = time

	return ([hour, minute, second]).map(function(n) {
		n = n.toString()
		return n[1] ? n : '0' + n
	}).join(':')
}

function formatLocation(longitude, latitude) {
	if (typeof longitude === 'string' && typeof latitude === 'string') {
		longitude = parseFloat(longitude)
		latitude = parseFloat(latitude)
	}

	longitude = longitude.toFixed(2)
	latitude = latitude.toFixed(2)

	return {
		longitude: longitude.toString().split('.'),
		latitude: latitude.toString().split('.')
	}
}
var dateUtils = {
	UNITS: {
		'年': 31557600000,
		'月': 2629800000,
		'天': 86400000,
		'小时': 3600000,
		'分钟': 60000,
		'秒': 1000
	},
	humanize: function(milliseconds) {
		var humanize = '';
		for (var key in this.UNITS) {
			if (milliseconds >= this.UNITS[key]) {
				humanize = Math.floor(milliseconds / this.UNITS[key]) + key + '前';
				break;
			}
		}
		return humanize || '刚刚';
	},
	format: function(dateStr) {
		var date = this.parse(dateStr)
		var diff = Date.now() - date.getTime();
		if (diff < this.UNITS['天']) {
			return this.humanize(diff);
		}
		var _format = function(number) {
			return (number < 10 ? ('0' + number) : number);
		};
		return date.getFullYear() + '/' + _format(date.getMonth() + 1) + '/' + _format(date.getDate()) + '-' +
			_format(date.getHours()) + ':' + _format(date.getMinutes());
	},
	parse: function(str) { //将"yyyy-mm-dd HH:MM:ss"格式的字符串，转化为一个Date对象
		var a = str.split(/[^0-9]/);
		return new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);
	},
	dateNomal: function(target) {
		return dateUtils.dateToString(target, "yyyy-MM-dd hh:mm:ss");
	},
	dateToString: function(target, fmt) {
		var o = {
			"M+": target.getMonth() + 1, //月份 
			"d+": target.getDate(), //日 
			"h+": target.getHours(), //小时 
			"m+": target.getMinutes(), //分 
			"s+": target.getSeconds(), //秒 
			"q+": Math.floor((target.getMonth() + 3) / 3), //季度 
			"S": target.getMilliseconds() //毫秒 
		};
		if (/(y+)/.test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (target.getFullYear() + "").substr(4 - RegExp.$1.length));
		}
		for (var k in o) {
			if (new RegExp("(" + k + ")").test(fmt)) {
				fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[
					k]).length)));
			}
		}
		return fmt;
	}
};
var GPS = {
	PI: 3.14159265358979324,
	x_pi: 3.14159265358979324 * 3000.0 / 180.0,

	transformLat: function(x, y) {
		var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x))
		ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0
		ret += (20.0 * Math.sin(y * this.PI) + 40.0 * Math.sin(y / 3.0 * this.PI)) * 2.0 / 3.0
		ret += (160.0 * Math.sin(y / 12.0 * this.PI) + 320 * Math.sin(y * this.PI / 30.0)) * 2.0 / 3.0
		return ret
	},
	transformLon: function(x, y) {
		var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x))
		ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0
		ret += (20.0 * Math.sin(x * this.PI) + 40.0 * Math.sin(x / 3.0 * this.PI)) * 2.0 / 3.0
		ret += (150.0 * Math.sin(x / 12.0 * this.PI) + 300.0 * Math.sin(x / 30.0 * this.PI)) * 2.0 / 3.0
		return ret
	},
	// 坐标转换
	delta: function(lat, lon) {
		var a = 6378245.0 //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
		var ee = 0.00669342162296594323 //  ee: 椭球的偏心率。
		var dLat = this.transformLat(lon - 105.0, lat - 35.0)
		var dLon = this.transformLon(lon - 105.0, lat - 35.0)
		var radLat = lat / 180.0 * this.PI
		var magic = Math.sin(radLat)
		magic = 1 - ee * magic * magic
		var sqrtMagic = Math.sqrt(magic)
		dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * this.PI)
		dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * this.PI)
		return {
			'lat': dLat,
			'lon': dLon
		}
	},
	// 判断是否为国外坐标
	outOfChina: function(lat, lon) {
		if (lon < 72.004 || lon > 137.8347) {
			return true
		}
		if (lat < 0.8293 || lat > 55.8271) {
			return true
		}
		return false
	},
	// GPS---高德
	gcj_encrypt: function(wgsLat, wgsLon) {
		if (this.outOfChina(wgsLat, wgsLon)) {
			return {
				'lat': wgsLat,
				'lon': wgsLon
			}
		}

		var d = this.delta(wgsLat, wgsLon)
		return {
			'lat': wgsLat + d.lat,
			'lon': wgsLon + d.lon
		}
	},

	//度分转换为经纬度
	DuFenToGPS(dm) {
		if (dm == null) {
			return 0;
		}
		// console.log(dm)
		var dm = dm.replace(" ", "");
		// console.log(dm)

		// console.log((dm.lastIndexOf(".") - 2))
		// console.log(dm.substring(0, dm.lastIndexOf(".") - 2))

		var d = Number(dm.substring(0, dm.lastIndexOf(".") - 2));
		// console.log(d)
		// 兼容经纬度的转换
		var fen = (dm.substring(0, dm.lastIndexOf(".") - 2));

		var lat = (fen / 60) + Math.abs(d);
		if (lat < 0) {
			lat = -lat;
		}

		// console.log(lat)
		// lat = lat * 1000000 / 1000000
		console.log(lat)
		// return (format("%.7f", lat));
		return lat;
	},




}

export default {
	formatTime: formatTime,
	formatLocation: formatLocation,
	dateUtils: dateUtils,
	isRealNum: isRealNum,
	GPS: GPS
}